import {
  CanvasDrawingServiceInitOptions,
  DrawCircleOptions,
  DrawEllipsisShadowOptions,
  DrawShadowOptions,
  DrawTextInCoordinatesOptions,
  ICanvasDrawingService,
} from '../ICanvasDrawingService';

/**
 * @todo: подумать, м.б. класс со статическими методами будет здесь выгоднее
 */
export class CanvasDrawingService implements ICanvasDrawingService {
  private readonly ctx: CanvasRenderingContext2D;
  private readonly dpr: number;

  public constructor(options: CanvasDrawingServiceInitOptions) {
    this.ctx = options.context;
    this.dpr = options.dpr;
  }

  public drawCircle = (opts: DrawCircleOptions): void => {
    const { pinCoords, radius, color } = opts;
    const [pointX, pointY] = this.getPinCoords(pinCoords);

    this.ctx.beginPath();

    this.ctx.fillStyle = color;
    this.ctx.arc(pointX * this.dpr, pointY * this.dpr, radius * this.dpr, 0, 2 * Math.PI);
    this.ctx.fill();

    this.ctx.closePath();
  };

  public drawTextInCoordinates = (opts: DrawTextInCoordinatesOptions): void => {
    const { pinCoords, color, text } = opts;

    if (text) {
      const [pointX, pointY] = this.getPinCoords(pinCoords);

      this.ctx.beginPath();

      this.ctx.font = `${10 * this.dpr}px/1 Lato`;
      this.ctx.textAlign = 'center';
      this.ctx.textBaseline = 'alphabetic';
      this.ctx.fillStyle = color;
      this.ctx.fillText(text, pointX * this.dpr, (pointY + 4) * this.dpr);

      this.ctx.closePath();
    }
  };

  public drawShadow = (opts: DrawShadowOptions): void => {
    const { shadowColor = '', shadowBlur = 0, shadowOffsetY = 0, shadowOffsetX = 0 } = opts;

    this.ctx.shadowColor = shadowColor;
    this.ctx.shadowBlur = shadowBlur;
    this.ctx.shadowOffsetY = shadowOffsetY;
    this.ctx.shadowOffsetX = shadowOffsetX;
  };

  public drawEllipsisShadow(opts: DrawEllipsisShadowOptions): void {
    const { pinCoords, radius, color } = opts;
    const [pointX, pointY] = this.getPinCoords(pinCoords);

    const radiusX = radius * 0.6;

    this.ctx.beginPath();
    this.ctx.fillStyle = color;
    this.ctx.ellipse(
      pointX * this.dpr,
      (pointY + radiusX + 1) * this.dpr,
      radius * 1.3 * this.dpr,
      radiusX * this.dpr,
      0,
      0,
      2 * Math.PI,
    );
    this.ctx.fill();
    this.ctx.closePath();
  }

  public clearRect = (x: number, y: number, w: number, h: number): void => {
    this.ctx.clearRect(x, y, w, h);
  };

  private getPinCoords(pinCoords: [number, number]): [number, number] {
    const [pointXRaw, pointYRaw] = pinCoords;

    return [Math.round(pointXRaw), Math.floor(pointYRaw)];
  }
}
